import React from 'react'
import { Button, Modal, Grid, Icon } from 'semantic-ui-react'
import { dispatch } from '@rematch/core';
import ImageAvater from '../../../../drive/Components/ImageAvater';


class ViewUserCard extends React.Component {

    handleClose = () => {
        dispatch.initiatives.viewUserModalOpen(false);
    }

    createParentsArray = (nodes) => {
        nodes.forEach(node => {
            this.state.nodeMap.set(node._id, node);
            node.breadcrumbs = [];
            if (node.parentOrganizationId && this.props.selectedOrganisation && node.parentOrganizationId !== this.props.selectedOrganisation.id) {
                let parentObject = this.state.nodeMap.get(node.parentOrganizationId);
                node.breadcrumbs = [...parentObject.breadcrumbs]
            }
            node.breadcrumbs.push({
                label: node.label,
                id: node._id,
                parentId: node.parentOrganizationId
            });
            if (node.nodes) {
                this.createParentsArray(node.nodes);
            }
        })
    }

    render() {
        let userOrgRole = this.props.viewUserDetails && this.props.viewUserDetails.accountUserId && this.props.viewUserDetails.accountUserId.organizations && this.props.viewUserDetails.accountUserId.organizations.length && this.props.viewUserDetails.accountUserId.organizations.filter((item) => { return item.id.toString() === this.props.selectedOrganisation.id.toString() })
        const inlineStyle = {
            modal: {
                marginTop: '0px !important',
                marginLeft: 'auto',
                marginRight: 'auto'
            }
        };
        return (
            <Modal
                size='mini'
                open={this.props.isViewUserModalOpen}
                centered style={inlineStyle.modal} className="editRoleModal basicModal"
                closeOnEscape={false}
                closeOnDimmerClick={false}
            >
                <Modal.Header style={{ color: '#3fa9f5' }}>User Details
            </Modal.Header>
                <Modal.Content>

                    <Grid>
                        <Grid.Row>
                            <Grid.Column>
                                <ImageAvater user={this.props.viewUserDetails.accountUserId} />
                                <Grid.Row className="text-cap">
                                    <strong>{this.props.viewUserDetails && this.props.viewUserDetails.accountUserId ? this.props.viewUserDetails.accountUserId.firstName + ' ' + this.props.viewUserDetails.accountUserId.lastName : ''}</strong>
                                </Grid.Row>
                                <Grid.Row>
                                    <span>{this.props.viewUserDetails && this.props.viewUserDetails.accountUserId && this.props.viewUserDetails.accountUserId.email}</span>
                                </Grid.Row>
                                <Grid.Row>
                                    <span>{userOrgRole && userOrgRole[0] && userOrgRole[0].role}</span>
                                </Grid.Row>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <div style={{ color: '#3fa9f5' }}>Current Team and Role</div>
                        </Grid.Row>
                        <Grid.Row>
                            <Icon name='sitemap' color="grey" />
                            <div>{this.props.organizationsMap.get(this.props.suborgdata._id).parents}</div>
                        </Grid.Row>
                        <Grid.Row>
                            <Icon name='user' color="grey" />
                            <div>{this.props.viewUserDetails && this.props.viewUserDetails.role}</div>
                        </Grid.Row>

                    </Grid>

                </Modal.Content>
                <Modal.Actions>
                    <Button className="button-cancel" id='cancelBtn' onClick={this.handleClose}> Cancel
                    </Button>

                </Modal.Actions>
            </Modal >
        )
    }
}

export default ViewUserCard